import { render, staticRenderFns } from "./productionModule.vue?vue&type=template&id=2bea466a&scoped=true"
import script from "./productionModule.vue?vue&type=script&lang=js"
export * from "./productionModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea466a",
  null
  
)

export default component.exports